"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TS = void 0;
const moment_1 = __importDefault(require("moment"));
class TS {
    static generate(startTimeStamp, length, resolution, value) {
        return [...Array(length).keys()].map((i) => ({
            time: moment_1.default
                .unix(startTimeStamp)
                .startOf(resolution)
                .add(i, resolution)
                .unix(),
            value
        }));
    }
    static aggregateByTime(timeSeries) {
        const reduced = timeSeries
            .reduce((dict, current) => {
            const key = current.time;
            const value = dict.has(key) ? dict.get(key).value + current.value : current.value;
            return dict.set(key, Object.assign(Object.assign({}, current), { value }));
        }, new Map())
            .values();
        return Array.from(reduced);
    }
    static inRange(timeSeries, startTimeStamp, endTimeStamp) {
        return timeSeries.filter((timeSeriesElement) => timeSeriesElement.time >= startTimeStamp && timeSeriesElement.time <= endTimeStamp);
    }
}
exports.TS = TS;
//# sourceMappingURL=TimeSeries.js.map